var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUpWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle 1241 Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "In-Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jobOverview-Copy-2",
    transform: "translate(-44.000000, -250.000000)",
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-1241-Copy-6",
    transform: "translate(54.000000, 256.000000) scale(-1, 1) rotate(90.000000) translate(-54.000000, -256.000000) ",
    points: "57.8371752 246 48 256 57.8371752 266 60 263.434763 52.6862932 256 60 248.565237"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronUpWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-up-white.590dc99220fceacd7f557a5f1f50acb8.svg";